import { Assets } from '@helpers/Constants/Assets';
import { LogoProps } from '@helpers/Models';

export const Logo = ({ isLogin }: LogoProps): JSX.Element => {
  return (
    <img
      alt="Logo Img"
      src={Assets.LOGO}
      className={`mx-auto ${isLogin ? 'h-24' : 'h-16'} w-auto`} // Use larger image on login screen, smaller otherwise
    />
  );
};
